import api from '@/api/products';
import globalApi from '@/api/globals';

const state = () => ({

  moveToAccountSearch: [],
  moveToAccountSearched: false,
  moveToAccountSearchLoading: false,
  moveToAccountSearchError: null,

  moveToAnotherAccount: '',
  moveToAnotherAccountProductId: '',
  moveToAnotherAccountLoading: false,
  moveToAnotherAccountError: null,

  moveToNewAccount: '',
  moveToNewAccountProductId: '',
  moveToNewAccountLoading: false,
  moveToNewAccountError: null,

});

const getDefaultState = JSON.parse(JSON.stringify(state()));

const mutations = {

  ACCOUNT_SEARCH_BEGIN(state){
    state.moveToAccountSearch = [];
    state.moveToAccountSearchLoading = true;
    state.moveToAccountSearchError = null;
  },
  ACCOUNT_SEARCH_SUCCESS(state,data){
    state.moveToAccountSearch = data;
    state.moveToAccountSearched = true;
    state.moveToAccountSearchLoading = false;
    state.moveToAccountSearchError = null;
  },
  ACCOUNT_SEARCH_FAILED(state,data){
    state.moveToAccountSearched = true;
    state.moveToAccountSearchLoading = false;
    state.moveToAccountSearchError = data;
  },

  SET_MOVE_TO_ANOTHER_ACCOUNT_PRODUCT(state,product){
    state.moveToAnotherAccountProductId = product;
  },
  MOVE_TO_ANOTHER_ACCOUNT_BEGIN(state){
    state.moveToAnotherAccount = '';
    state.moveToAnotherAccountLoading = true;
    state.moveToAnotherAccountError = null;
  },
  MOVE_TO_ANOTHER_ACCOUNT_SUCCESS(state,data){
    state.moveToAnotherAccount = data;
    state.moveToAnotherAccountLoading = false;
    state.moveToAnotherAccountError = null;
  },
  MOVE_TO_ANOTHER_ACCOUNT_FAILED(state,data){
    state.moveToAnotherAccountLoading = false;
    state.moveToAnotherAccountError = data;
  },  

  SET_MOVE_TO_NEW_ACCOUNT_PRODUCT(state,product){
    state.moveToNewAccountProductId = product;
  },
  MOVE_TO_NEW_ACCOUNT_BEGIN(state){
    state.moveToNewAccount = '';
    state.moveToNewAccountLoading = true;
    state.moveToNewAccountError = null;
  },
  MOVE_TO_NEW_ACCOUNT_SUCCESS(state,data){
    state.moveToNewAccount = data;
    state.moveToNewAccountLoading = false;
    state.moveToNewAccountError = null;
  },
  MOVE_TO_NEW_ACCOUNT_FAILED(state,data){
    state.moveToNewAccountLoading = false;
    state.moveToNewAccountError = data;
  },

  RESET_MOVE_TO_STORE(state){
    Object.assign(state, getDefaultState);
  },

};

const actions = {

  async SEARCH_ACCOUNT_TO_MOVE({commit},search){
    commit('ACCOUNT_SEARCH_BEGIN');
    try{
      const resp = await api.searchAccounts(search);
      if(resp.status === 200){
        commit('ACCOUNT_SEARCH_SUCCESS',resp.data);
      }else{
        commit('ACCOUNT_SEARCH_FAILED',resp.data);
      }
    }
    catch(error){
      commit('ACCOUNT_SEARCH_FAILED',error.response.data);
    }
  },

  async MOVE_TO_ANOTHER_ACCOUNT({commit,state},account){
    commit('MOVE_TO_ANOTHER_ACCOUNT_BEGIN');
    try{
      const resp = await api.moveToAnotherAccount(state.moveToAnotherAccountProductId,account);
      if(resp.status === 200){
        commit('MOVE_TO_ANOTHER_ACCOUNT_SUCCESS',resp.data);
      }else{
        commit('MOVE_TO_ANOTHER_ACCOUNT_FAILED',resp.data);
      }
    }
    catch(error){
      commit('MOVE_TO_ANOTHER_ACCOUNT_FAILED',error.response.data);
    }
  },

  async MOVE_TO_NEW_ACCOUNT({commit,state}){
    commit('MOVE_TO_NEW_ACCOUNT_BEGIN');
    try{
      const resp = await api.moveToNewAccount(state.moveToNewAccountProductId);
      if(resp.status === 200){
        commit('MOVE_TO_NEW_ACCOUNT_SUCCESS',resp.data);
      }else{
        commit('MOVE_TO_NEW_ACCOUNT_FAILED',resp.data);
      }
    }
    catch(error){
      commit('MOVE_TO_NEW_ACCOUNT_FAILED',error.response.data);
    }
  },

};

const getters = {

  getMoveToAccountSearch: state => state.moveToAccountSearch.map(e=>({
    id: e.account_id,
    name: e.business_name
  })),
  getMoveToAccountSearchLoading: state => state.moveToAccountSearchLoading,
  getMoveToAccountSearched: state => state.moveToAccountSearched,
  getMoveToAccountSearchError: state => state.moveToAccountSearchError,

  getMoveToAnotherAccount: state => state.moveToAnotherAccount,
  getMoveToAnotherAccountProductId: state => state.moveToAnotherAccountProductId,
  getMoveToAnotherAccountLoading: state => state.moveToAnotherAccountLoading,
  getMoveToAnotherAccountError: state => state.moveToAnotherAccountError,

  getMoveToNewAccount: state => state.moveToNewAccount,
  getMoveToNewAccountProductId: state => state.moveToNewAccountProductId,
  getMoveToNewAccountLoading: state => state.moveToNewAccountLoading,
  getMoveToNewAccountError: state => state.moveToNewAccountError,

};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
